import { Request } from './Request';

export class FilterPagination {
    constructor(paginationWrapper) {
        this.paginationWrapper = paginationWrapper;
        this.query = [];

        this.AJAX = new Request();

        this.init();
    }

    init() {
        this.checkSearchParams();
        this.paginationHandlers();
    }

    prepareFormData = (href) => {
        const data = [];

        if (href) {
            const { searchParams } = new URL(href);

            Array.from(searchParams.keys()).forEach((item) => {
                data.push({ key: item, value: searchParams.get(item) });
            });
        }

        const formData = new FormData();
        data.forEach((item) => {
            formData.append(item.key, item.value);
        });

        return formData;
    };

    paginationHandlers() {
        if (!this.paginationWrapper) return;

        this.paginationWrapper.addEventListener('click', (evt) => {
            evt.preventDefault();

            const { href } = evt.target;
            if (!href) return;

            const query = this.prepareFormData(href);
            this.AJAX.request(query);
        });
    }

    checkSearchParams() {
        const { searchParams } = new URL(window.location);
        const formData = new FormData();
        formData.append('PAGEN_1', searchParams.get('PAGEN_1'));
        this.AJAX.setInitPreviousFormData(formData);
    }
}
